export enum SeatingModal {
  Resale = "resale",
  MinPurchase = "minpurchase",
  FullPurchase = "fullpurchase",
  Isolated = "isolated",
}
